import { override } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import app from 'flarum/forum/app';

interface Badge extends Model {
  name: () => string;
  icon: () => string;
  order: () => number;
  image: () => string;
  description: () => string;
  isVisible: () => boolean;
  earnedAmount: () => string;
  category: () => any;
  backgroundColor: () => string;
  iconColor: () => string;
  labelColor: () => string;
}

interface BadgeCategory extends Model {
  name: () => string;
  order: () => number;
  description: () => string;
  isEnabled: () => boolean;
  isTable: () => boolean;
  users: () => any[];
  badges: () => Badge[];
}

export default function () {
  if (!app.routes.badges) return;

  /**
   * fix: 修复TypeError: subject.badge().icon is not a function
   * 在个别页面刷新后会触发此bug，原因是没获取到userBadges关联的badge数据，这里先调用一次user_badges接口
   * 后续需要再php里fix此bug
   */
  let loading = false;
  override(app.notificationComponents.badgeReceived.prototype, 'excerpt', function (excerpt) {
    if (this.attrs.notification.subject().badge()) {
      return excerpt();
    }

    if (!loading) {
      loading = true;
      app.store
        .find('user_badges')
        .then(() => {
          m.redraw();
        })
        .finally(() => {
          loading = false;
        });
    }

    return null;
  });
}
